
  import React from "react"
  import Component from "/srv/newsclouds-gatsby/src/layouts/index.js"
  import data from "/srv/newsclouds-gatsby/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js